<template>
  <div v-if="displayLegalLink" class="mt-12" id="guest-legal-link">
    <router-link to="/legal" class="text-button-guest-primary">Legal</router-link>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useFeatureFlags } from '@/common/composables/useFeatureFlags'

const { isLegalLinkCheckoutEnabled } = useFeatureFlags()

const route = useRoute()
const isShowListOrPayment = computed<boolean>(
  () => route.name === 'setShow' || route.name === 'payment',
)
const displayLegalLink = computed<boolean>(
  () => isLegalLinkCheckoutEnabled.value && isShowListOrPayment.value,
)
</script>
